export default __webpack_public_path__ + "static/media/topic2.9268cf11.png";